// extracted by mini-css-extract-plugin
export var childrenContainer = "_ad-0";